export default {
  timerMessage: '19122018-152801-0019',
  timerWarning: '19122018-152801-0020'
};
